import { EShowComponentLayout } from '../model';

export const getShowElementId = (
  showId: string,
  layout: EShowComponentLayout,
  isButton?: boolean
): string => {
  return `${isButton ? 'button-' : ''}${layout}-${showId}`;
};
